<template>
  <div class="works">
    <div class="work" v-for="work in works">
      <div class="work__title">{{ work.title }}</div>
      <div class="work__genre">{{ work.genre }}</div>
      <WorkImages :images="work.images"></WorkImages>
      <div class="work__description">{{ work.description }}</div>
      <div class="work__private" v-if="!work.link"># Private Project</div>
      <a :href="work.link" target="_blank" class="work__link" v-if="work.link">{{ work.link }}</a>
      <div class="work__skills skills">
        <span class="skills__skill" v-for="skill in work.skills">{{ skill }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import WorkImages from './WorkImages'
export default {
  components: {
    WorkImages
  },
  name: 'works',
  data () {
    return {
      works: [
        {
          title: 'Hostly',
          genre: 'Vacation Rental Software',
          description: 'Hostly is a cloud based property management software that enables vacation rental owners and property managers to save their time, and spend more energy on building better relations with their customers.',
          skills: ['Ruby on Rails', 'Vue.js', 'Ruby', 'ES7', 'Browserify', 'Wercker'],
          isPublished: false,
          link: null,
          images: ['/static/Hostly01.png', '/static/Hostly02.png', '/static/Hostly03.png', '/static/Hostly04.png', '/static/Hostly05.png', '/static/Hostly06.png', '/static/Hostly07.png', '/static/Hostly08.png'],
          role: 'Product Owner. Tech Lead.'
        },
        {
          title: 'Portfolio',
          genre: 'Website',
          description: 'To showcase my profile, skills, and experiences to the world. I just wanted a sandbox to mess with new technologies.',
          skills: ['Vue.js', 'vue-cli', 'vue-router', 'ES7', 'Webpack', 'GitHub Pages'],
          isPublished: false,
          link: 'https://andoshin11.github.io/',
          images: ['/static/portfolio01.png', '/static/portfolio02.png'],
          role: 'Personal Project'
        },
        {
          title: 'Random Pocket',
          genre: 'Slack Bot',
          description: 'Post random articles from Pocket archives to a Slack channel every 12 hours',
          skills: ['Google Apps Script', 'Pocket API', 'Slack API'],
          isPublished: false,
          link: null,
          images: ['/static/pocket01.png'],
          role: 'Personal Project'
        },
        {
          title: 'gig 360°',
          genre: 'Hackathon Product',
          description: 'gig 360° is a community where Music Lovers share their exciting moments by posting live 360 streaming videos. Award winning product at AngelHack Osaka 2017.',
          skills: ['Ruby on Rails', 'Vue.js', 'Ruby', 'ES7', 'Browserify'],
          isPublished: false,
          link: 'http://www.hackathon.io/83831',
          images: ['/static/gig01.png', '/static/gig02.png', '/static/gig03.png', '/static/gig04.png', '/static/gig05.png'],
          role: 'Personal Project'
        },
        {
          title: 'Airbnb Crawler',
          genre: 'Data Analysis Script',
          description: 'Python script to crawl Airbnb and collect vacation rental business data.',
          skills: ['Python', 'BeautifulSoup', 'Tableau'],
          isPublished: false,
          link: 'https://goo.gl/5HZUTo',
          images: ['/static/scrape01.png', '/static/scrape02.png', '/static/scrape03.png', '/static/scrape04.png', '/static/scrape05.png'],
          role: 'Personal Project'
        },
        {
          title: 'Cloud Miner',
          genre: 'Bitcoin mining tool / Hackathon Product',
          description: 'Cloud mining tool works on browsers. Using JavaScipt and WebGL, this tool caliculates millions of SHA256 Hash on client machines to find a nonce for the new block. The results will be sent to the central server for validation.',
          skills: ['Ruby on Rails', 'Vue.js', 'Ruby', 'ES7', 'Browserify', 'SHA256'],
          isPublished: false,
          link: null,
          images: ['/static/bitcoin01.gif', '/static/bitcoin02.png'],
          role: 'Personal Project'
        },
        {
          title: 'CINELOG',
          genre: 'Movie Diary Application',
          description: 'Personal dialy to keep all the good memories with fantastic films.',
          skills: ['Ruby on Rails', 'Vue.js', 'Ruby', 'ES7', 'Browserify', 'OAuth2', 'The Movie Database API', 'Twitter API'],
          isPublished: false,
          link: null,
          images: ['/static/cinelog01.png', '/static/cinelog02.gif'],
          role: 'Personal Project'
        }
      ]
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
$black: #2c3e50;
$green: #41BAA4;
$green-dark: #067e76;

body {
  font-size: 12px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: $green-dark;
  text-decoration: underline;
  cursor: pointer;
  &:hover{
    opacity: .7;
  }
}

.skills {
  &__skill {
    display: inline-block;
    border: 1px solid $black;
    border-radius: 3px;
    padding: 0 5px;
    font-size: 16px;
    line-height: 1.5;
    margin-right: 3px;
    margin-bottom: 6px;
  }
}

.work {
  margin-bottom: 50px;
  &__description {
    font-size: 18px;
    line-height: 1.5;
  }
  &__genre {
    line-height: 1.5;
    font-size: 18px;
    margin-bottom: 30px;
  }
  &__link {
    line-height: 3;
    font-size: 20px;
  }
  &__private {
    font-size: 20px;
    line-height: 3;
    text-decoration: underline;
    text-decoration-color: $green;
  }
  &__title {
    color: $green;
    font-size: 28px;
    font-style: italic;
    font-weight: bold;
    line-height: 2;
  }
}

.works {
  display: block;
  width: 60%;
  margin: auto;
  padding-bottom: 300px;
  &__header {
    font-size: 32px;
    line-height: 5;
    font-weight: bold;
  }
}

@media screen and (max-width: 767px) {
  .works {
    width: 100%;
    padding-bottom: 100px;
  }
  .work {
    &__description {
      width: 90%;
      margin: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Works.vue?0d4dab07